import { Box, Chip } from "@mui/material";
import {
  Grid,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from "@mui/material";
import React from "react";
import formatDate from "utils/formatDate";
import CopyToClipboard from "../copy/CopyToClipboard";

const GridListItem = (props) => {
  const {
    title,
    subTitle,
    copyValue,
    isDate = false,
    size = 6,
    isChip = false,
    chipProps = {},
    gridProps = {},
    secondaryAction,
    primaryTextColor = "#757575",
    secondaryTextColor = "#212121",
    primaryFontWeight = 500,
    secondaryFontWeight = 500,
    marginBottom = "6px",
  } = props;

  const getSubTitleContent = () => {
    const subTitleContent = subTitle
      ? isDate
        ? formatDate(subTitle, "MM/DD/YYYY")
        : subTitle
      : "—";

    const content = isChip ? (
      <Chip
        size={chipProps?.size ?? "small"}
        color={chipProps?.color ?? "default"}
        label={subTitleContent}
        {...chipProps}
      />
    ) : (
      subTitleContent
    );

    if (!copyValue || !subTitle) {
      return content;
    }

    return (
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        {content}
        {copyValue && <CopyToClipboard value={copyValue} />}
      </Box>
    );
  };

  return (
    <Grid item xs={size} {...gridProps}>
      <ListItem sx={{ paddingLeft: 0 }}>
        <ListItemText
          primary={title}
          secondary={getSubTitleContent()}
          primaryTypographyProps={{
            style: {
              fontWeight: primaryFontWeight,
              fontSize: "12px",
              color: primaryTextColor,
              marginBottom: marginBottom,
            },
          }}
          secondaryTypographyProps={{
            component: "div",
            style: {
              fontWeight: secondaryFontWeight,
              fontSize: "14px",
              color: secondaryTextColor,
              overflowWrap: "break-word",
            },
          }}
        />
        {secondaryAction && (
          <ListItemSecondaryAction>{secondaryAction}</ListItemSecondaryAction>
        )}
      </ListItem>
    </Grid>
  );
};

export default GridListItem;
